import { useEffect, useState } from "react";
import { INSTANCE } from "../../lib/instance";

type Props = {
  appId: string;
  breadcrumb: string;
  tenant?: string;
  project?: string;
  version?: string;
};

function formatTime(d: Date): string {
  return [d.getHours(), d.getMinutes(), d.getSeconds()]
    .map((n) => String(n).padStart(2, "0"))
    .join(":");
}

export function Statusbar({
  appId,
  breadcrumb,
  tenant = INSTANCE.organizationName,
  project = INSTANCE.organizationUnit,
  version = "v 2.0",
}: Props) {
  const [now, setNow] = useState<string>(() => formatTime(new Date()));

  useEffect(() => {
    const id = window.setInterval(() => setNow(formatTime(new Date())), 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="os-statusbar" data-app={appId}>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
        <span className="dot" style={{ background: "var(--ok)" }} />
        system · ok
      </span>
      <span className="sep">·</span>
      <span>sync · {now}</span>
      <span className="sep">·</span>
      <span>db · postgres</span>
      <span className="sep">·</span>
      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {breadcrumb}
      </span>
      <span style={{ flex: 1 }} />
      <span>{tenant}</span>
      <span className="sep">·</span>
      <span>{project}</span>
      <span className="sep">·</span>
      <span>{version}</span>
    </div>
  );
}
